import React, {useState} from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
import Button from "../button";
import { DIY_INTENT } from "../post-inspection-diy/constant";
import styles from "./styles.css";
import PostInspectionDiyTokenDetails from "./token-details";
import { DIY_TOKEN_STATES } from "./constant";
import { PRICE_DISCOVERY, PURCHASE_REQUEST_STATUS } from "../../../constants/seller-diy-constants";

const PostInspectionDiyTokenEligiblePopup = loadable(() => import("../post-inspection-diy-token-eligible-popup"));
const PostInspectionDiyPriceAcceptPopup = loadable(() => import("../post-inspection-diy-price-accept-popup"));
// eslint-disable-next-line max-statements
const PostInspectionDiyTokenContainer = ({
    purchaseRequest,
    getDiyIntentConnect,
    inspectionResponse,
    setDiyIntentConnect,
    setShowTokenEligibleContainer = () => {},
    setHammerSwipeConnect
}) => {
    const { token, appointmentId, priceDiscovery, purchaseRequestStatus } = inspectionResponse || {};
    const { diyIntent = "", tokenDetails = {} } = purchaseRequest || {};
    const isTokenIntent = diyIntent === DIY_INTENT.TOKEN;
    const { tokenStatus: status = "" } = tokenDetails || {};
    const diyIntentData = isTokenIntent ? DIY_TOKEN_STATES[status] : DIY_TOKEN_STATES[DIY_INTENT.DEFAULT];
    const {title = "", ctaText = "", image = ""} = diyIntentData || {};
    const [showTokenEligibleStrip, setShowTokenEligibleStrip] = useState(isTokenIntent);
    const [showTokenProcessedDetails, setShowTokenProcessedDetails] = useState(false);
    const isPriceAccepted = priceDiscovery === PRICE_DISCOVERY.ACCEPTED;

    const showTokenEligibleStripHandler = () => {
        setShowTokenEligibleStrip(true);
    };

    const getTokenHandler = () => {
        const  payload = {
            "intent": DIY_INTENT.TOKEN
        };
        getDiyIntentConnect(token, payload).then((res) => {
            setDiyIntentConnect(res.intent);
            showTokenEligibleStripHandler(true);
        }).catch(() => {});
    };

    const openTokenDetails = () => {
        setShowTokenProcessedDetails(true);
    };

    // eslint-disable-next-line consistent-return
    const stripClickHandler = () => {
        if (diyIntent === DIY_INTENT.TOKEN) openTokenDetails();
        else getTokenHandler();
    };

    const handlePricePopupClose = () => {
        setShowTokenEligibleContainer(false);
        setHammerSwipeConnect(true);
    };

    const renderStrip = () => {
        return (
            <div styleName={"styles.getTokenWrapper"}>
                <p>
                    <img src={image} alt="completed"/>
                    {title}
                </p>
                {ctaText && <Button text={ctaText}
                    onClick={stripClickHandler}
                    styleName={`${diyIntent !== DIY_INTENT.TOKEN ? "styles.tokenWrapper" : "styles.viewDetails"}`} />}
            </div>);
    };

    if (!diyIntentData) {
        return null;
    }

    if (!isPriceAccepted || purchaseRequestStatus !== PURCHASE_REQUEST_STATUS.CREATED) {
        setHammerSwipeConnect(false);
        return (
            <PostInspectionDiyPriceAcceptPopup
                onClose={handlePricePopupClose}
                onSuccess={() => setShowTokenEligibleStrip(false)}
            />);
    }
    if (showTokenProcessedDetails) {
        return (
            <PostInspectionDiyTokenDetails appointmentId={appointmentId}
                tokenDetails={tokenDetails}
                onClose={() => setShowTokenProcessedDetails(false)}/>);
    }
    if (showTokenEligibleStrip) return renderStrip();
    return (
        <PostInspectionDiyTokenEligiblePopup
            onClose={showTokenEligibleStripHandler}
            getTokenHandler={getTokenHandler} />);
};

PostInspectionDiyTokenContainer.propTypes = {
    purchaseRequest: PropTypes.object,
    getDiyIntentConnect: PropTypes.func,
    inspectionResponse: PropTypes.object,
    fetchTokenProcessedDetailsConnect: PropTypes.func,
    setDiyIntentConnect: PropTypes.func,
    setShowTokenEligibleContainer: PropTypes.bool,
    setHammerSwipeConnect: PropTypes.func
};

export default PostInspectionDiyTokenContainer;
